import React from 'react';
import {Col, Divider, Row, Typography} from "antd";

const { Title, Text } = Typography;

const NoSourcePanel = () => {
    return (
        <div
            style={{
                height: "200px"
            }}
        >
            <Title
                level={5}
                style={{marginTop: 16, marginBottom: 16, marginLeft: 16, float: "left"}}
            >
                Source
            </Title>
            <Divider />
            <Row>
                <Text type="warning" style={{marginLeft: 32, fontSize: 28}}>No source selected.</Text>
            </Row>
            <Row>
                <Text type="secondary" style={{marginLeft: 32, marginTop: 8, fontSize: 20}}>
                    Please, select any asset from the left panel or upload a new one with the "Upload" button.
                </Text>
            </Row>
        </div>
    );
};

export default NoSourcePanel;